interface ModelCardProps {
  image: string;
  title: string;
  desc: string;
  link: string;
  buttonText?: string;
}

const ModelCard: React.FC<ModelCardProps> = ({
  image,
  title,
  desc,
  link,
  buttonText = "See more",
}) => {
  return (
    <div className="text-center space-y-4">
        <p className="text-xl font-bold">{title}</p>
        <p className="text-xs md:text-sm text-gray-400 h-16">{desc}</p>
        <a href={link} className="text-green-600 hover:underline font-bold" target="_blank" rel="noopener noreferrer">
        {buttonText}
      </a>
        <img src={image} className="mx-auto" />
    </div>
  );
};

export default ModelCard;
